export default "__VITE_ASSET__e8b4ece9__"